module.exports = __webpack_public_path__ + "6b68c197f1cbfdc78889170b0f847816.png";